import axios from 'axios';
import purchrAxios from './purchrAxios';
import config from '../config/config';

// Public axios (no Firebase token attached) for endpoints that authenticate
// via signed URLs — same pattern as manageItem.service.js.
let publicApiUrl = 'http://localhost:5001/purchr-ce58e/us-central1/purchr';
if (config.ENV !== 'development') {
  publicApiUrl = 'https://us-central1-purchr-ce58e.cloudfunctions.net/purchr';
}
const publicAxios = axios.create({ baseURL: publicApiUrl });

export default class UsersService {
  static async me(generateToken) {
    let url = '/users/me'
    if(generateToken) {
      url = `${url}?generateToken=${generateToken}`
    }

    const response = await purchrAxios.get(url);
    return response.data;
  }

  static async createUser(userInfo) {
    console.log('Registering user.');
    const response = await purchrAxios.post(
      '/users/create',
      { ...userInfo },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  
  static async updateUser(userInfo) {
    console.log('Updating user settings:', userInfo);
    const response = await purchrAxios.put(
      '/users/me',
      userInfo,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  }

  /**
   * Read a user's current email-subscription state for a signed link.
   * Public — uses publicAxios so no Firebase token is attached.
   */
  static async getEmailPreferences({ email, sig }) {
    const response = await publicAxios.get('/users/email-preferences', {
      params: { email, sig },
    });
    return response.data;
  }

  /**
   * Flip the user's email-subscription state for a signed link.
   * Public — uses publicAxios so no Firebase token is attached.
   */
  static async setEmailPreferences({ email, sig, subscribed }) {
    const response = await publicAxios.post(
      '/users/email-preferences',
      { email, sig, subscribed },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  }

  static async verifyEmail() {
    const response = await purchrAxios.post(
      `/users/verify`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  static async sendResetPasswordEmail(email) {
    const response = await purchrAxios.post(
      '/users/forgot-password',
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  static validateUserInfo(userInfo, page = 'REGISTER') {
    if (!userInfo.email) {
      throw new Error(`Email is required`);
    }

    if (!userInfo.password) {
      throw new Error(
        page === 'REGISTER'
          ? `Password is required`
          : `Old password is required.`
      );
    }

    if (!userInfo.reTypePassword) {
      throw new Error(
        page === 'REGISTER'
          ? `Re-enter valid password`
          : `Re-enter valid new password`
      );
    }

    if (userInfo.password !== userInfo.reTypePassword) {
      throw new Error(
        page === 'REGISTER'
          ? `Passwords doesn't match`
          : `New passwords doesn't match`
      );
    }
  }
}
